<template>
  <div class="header">
    <div class="search">
      <el-select
        class="search-select"
        v-model="formInline.deparyment"
        placeholder="请选择部门"
      >
        <el-option label="区域一" value="shanghai"></el-option>
        <el-option label="区域二" value="beijing"></el-option>
      </el-select>
      <el-input
        class="search-input"
        v-model="formInline.searchValue"
        placeholder="请输入要查询关键字"
      ></el-input>
      <el-select
        class="search-select"
        v-model="formInline.filterVisit"
        placeholder="过滤访问"
      >
        <el-option label="区域一" value="shanghai"></el-option>
        <el-option label="区域二" value="beijing"></el-option>
      </el-select>
      <el-button
        type="primary"
        @click="onSearch"
        icon="el-icon-search"
        size="small"
        >查询</el-button
      >
      <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
        >刷新</el-button
      >
    </div>
    <div>
      <el-button
        size="small"
        icon="el-icon-plus"
        @click="onAdd"
        type="success"
        v-if="roleList[path].includes('_Add')"
        >新增</el-button
      >
      <el-button
        size="small"
        icon="el-icon-edit"
        @click="onEdit"
        type="info"
        v-if="roleList[path].includes('_Update')"
        >编辑</el-button
      >
      <el-button
        size="small"
        icon="el-icon-delete"
        @click="onRemove"
        type="danger"
        v-if="roleList[path].includes('_Delete')"
        >删除</el-button
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'deparymentSearchBar',
  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  data() {
    return {
      formInline: {
        searchValue: '',
        deparyment: '',
        filterVisit: '',
      },
      path: '',
    };
  },
  computed: {
    ...mapGetters(['roleList']),
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  methods: {
    // 搜索
    onSearch() {
      window.console.log(this.formInline);
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 增加
    onAdd() {
      this.$parent.$refs.addDeparyment.dialogFormVisible = true;
    },

    // 编辑
    onEdit() {
      this.$parent.$refs.editDeparyment.dialogFormVisible = true;
    },

    // 删除
    onRemove() {},
  },
};
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .search {
    display: flex;
    width: 600px;

    .search-input {
      margin: 0 10px;
      width: 300px;
    }

    .search-picker {
      width: 250px;
    }

    .search-select {
      margin-right: 10px;
    }
  }

  button {
    height: 40px;
  }
}
</style>
